export const libraryFileUrl = (id, action) => `${process.env.REACT_APP_BACKEND_URL}/api/admin/library/files/${encodeURIComponent(id)}/${action}`;

export const libraryHeaders = () => {
  const password = sessionStorage.getItem('admin_password');
  if (!password) {
    const error = new Error('Your admin session has expired. Please sign in again.');
    error.code = 'ADMIN_SESSION_EXPIRED';
    throw error;
  }
  return { Authorization: `Basic ${btoa(':' + password)}` };
};

export const librarySessionExpired = (error) => error.code === 'ADMIN_SESSION_EXPIRED' || error.response?.status === 401;

export const libraryError = async (error) => {
  if (librarySessionExpired(error)) return 'Your admin session has expired. Please sign in again.';
  if (error.code === 'ECONNABORTED') return 'This request took too long. Please retry or download the original.';
  let data = error.response?.data;
  if (data instanceof Blob) {
    try { data = JSON.parse(await data.text()); } catch (_) { data = null; }
  }
  return typeof data?.detail === 'string' ? data.detail : 'Unable to load this file. Please retry or download the original.';
};